export default __webpack_public_path__ + "static/MainBackground-db40355c9a5f9e2b47b5c627f264f3ac.jpeg";